<template>
  <div class="pt-5 m-3 page-header align-items-start min-vh-50 pb-11 border-radius-lg" :style="{
          backgroundImage:
            'url(' + require('@/assets/img/sevica-images/almacen.jpg') + ')',
        }">
    <span class="mask opacity-6"></span><!--bg-gradient-primary-->
    <div class="container">
      <!-- <div class="row justify-content-center">
        <div class="mx-auto text-center col-lg-5">
          <h1 class="mt-5 mb-2 text-white">{{ $t('key_loginpage_welcome') }}</h1>
          <p class="text-white text-lead">
            {{ $t('key_loginpage_welcome_message') }}
          </p>
        </div>
      </div> -->
    </div>
  </div>
  <div class="container">
    <div class="row mt-lg-n10 mt-md-n11 mt-n10 justify-content-center">
      <div class="mx-auto col-xl-4 col-lg-5 col-md-7">
        <div class="card z-index-0">
          <img class="pt-6 px-6" src="@/assets/img/logos/picko-logo/picko_positivo_color.png" alt="Sevica Logo">
          <div class="pt-4 text-center card-header text-primary">
            <!-- <h5 class="text-primary">{{ $t('key_loginpage_login') }}</h5> -->
            <span class="text-primary text-lead">
              {{ $t('key_loginpage_welcome_message') }}
            </span>
          </div>
          <div class="card-body">
            <form ref="loginForm" role="form" class="text-start needs-validation" novalidate>
              <div class="mb-3">
                <input id="email" v-model="email" class="form-control" type="email" :placeholder="$t('key_loginpage_email')" name="email" required/>
                <div class="invalid-feedback">
                  {{ $t('key_loginpage_invalid_email') }}
                </div>
              </div>
              <div class="mb-3">
                <input id="password" v-model="password" class="form-control" name="password" type="password" :placeholder="$t('key_loginpage_password')" required/>
                <div class="invalid-feedback">
                  {{ $t('key_loginpage_password_required') }}
                </div>
              </div>
              <div class="text-center">
                <soft-button class="my-4 mb-2" type="button" color="primary" full-width @click="login()">{{ $t('key_loginpage_login_button') }}
                </soft-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="position-fixed top-8 end-2 z-index-2">
      <soft-snackbar
        :show="showNotification"
        :title="notificationInfo.title"
        :description="notificationInfo.message"
        :icon="{ component: notificationInfo.status=='success'?'ni ni-check-bold':'ni ni-fat-remove' , color: notificationInfo.status=='success'?'success':'danger' }"
        :color="notificationInfo.status=='success'?'success':'danger'"
        @close-handler="showNotification = !showNotification"
      />
    </div>
  </div>
  <app-footer class="mt-7" />
</template>
<script>
import AppFooter from "@/examples/Footer.vue";
import SoftButton from "@/components/SoftButton.vue";
import { mapMutations } from "vuex";
import SoftSnackbar from "@/components/SoftSnackbar.vue";

export default {
  name: "LoginPage",
  components: {
    AppFooter,
    SoftButton,
    SoftSnackbar,
  },
  data() {
    return{
      showNotification: false,
      email:"",
      password:"",
      msgError:"",
      notificationInfo:{
        title: '',
        message: '',
        status: 'danger'
      },
    }
  },
  computed: {
    statusLogin() {
      return this.$store.state.user.entity.status;
    }
  },
  watch: {
    statusLogin() {
      if (this.statusLogin && this.statusLogin.logged) {
        if (this.$store.state.user.entity.data /* && this.$store.state.user.entity.data.roles.includes('CENTRAL') */)
        /* this.$router.push({ name: "Dashboard Admin" });
        else */
          this.$router.push({ name: "Dashboard" });
      } else if (this.statusLogin && this.statusLogin.error) {
        this.notificationInfo = {
          title: 'Ups! Error',
          message: this.statusLogin.error.error,
          status: 'error'
        }
        this.showNotification = true;
        this.closeNotification();
      }
    },    
  },
  mounted() {
    addEventListener('keyup', this.validateKeyListener)
  },
  created() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    removeEventListener('keyup', this.validateKeyListener)
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
    validateKeyListener(event) {
      if (event.code == "Enter") {
        this.login()
      }
    },
    login() {
      let form= this.$refs.loginForm;
      if (form.checkValidity()) {
        const model = {
          user: this.email,
          password: this.password,
        }; 
        this.$store.commit("user/login",model);
      }
      form.classList.add('was-validated')
    },
    closeNotification(){
      const self = this;
      setTimeout(function () {
        self.showNotification = false
      }, 2200);
    }
  },
};
</script>
